module.exports = __webpack_public_path__ + "static/media/DQ-anySystem.86c9e687.png";